import Vue from 'vue';
import config from './config';

Vue.prototype.$baseURL = config.baseURL;
Vue.prototype.$strapiURL = config.strapiURL;
